import React from "react";

import {ImFacebook} from 'react-icons/im';
import {BsInstagram} from 'react-icons/bs';
import {IoMdCall, IoIosArrowUp} from "react-icons/io"
import shelbyBarLogo from "../../assets/pictures/shelbyLogo-removebg.png";

const Footer = (props) => {
    function goTop(){
        window.scrollTo(0, 0);
    }
    return (
        <footer className="text-center text-white" style={{backgroundColor: "#141414"}} >
            <div className="footer__logo-position container pt-4">
                <section className="mb-4">
                   <a>
                       <img className="navbar-logo-position" src={shelbyBarLogo} alt="flowers"/>
                   </a>
                </section>
            </div>
            <div className="container pt-4">
                <section className="mb-4">
                    <a
                        className="footer-icon btn btn-link btn-floating btn-lg text-dark m-1"
                        href="https://www.facebook.com/shelbybarrr"
                        role="button"
                        data-mdb-ripple-color="dark"
                    ><i><ImFacebook/></i
                    ></a>
                    <a
                        className="footer-icon btn btn-link btn-floating btn-lg text-dark m-1"
                        href="https://www.instagram.com/accounts/login/?next=/shelby_bar_"
                        role="button"
                        data-mdb-ripple-color="dark"
                    ><i><BsInstagram/></i
                    ></a>
                    <a
                        className="footer-icon btn btn-link btn-floating btn-lg text-dark m-1"
                        href="tel:+49 174 3774389"
                        role="button"
                        data-mdb-ripple-color="dark"
                    ><i ><IoMdCall/></i
                    ></a>


                    <a
                        className="footer-icon btn btn-link btn-floating btn-lg text-dark m-1"
                        onClick={()=>goTop()}
                        role="button"
                        data-mdb-ripple-color="dark"
                    ><i className="fab fa-instagram"><IoIosArrowUp/></i
                    ></a>
                </section>

            </div>

            <div className="text-center text-white p-3" style={{backgroundColor: "#141414"}}>
                <a className="text-white" href="https://goo.gl/maps/KxEWuGEizXEcD3dA9">Adresse: Königsteiner Str. 65, 65812 Bad Soden am Taunus</a>
            </div>

        </footer>
    )
}

export default Footer;